import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { DefaultButton, PrimaryButton } from '@bingads-webui-react/fabric-with-signal';
import { FORM_EVENTS, FORM_STATES, useFormService } from '@bingads-webui-react/form-core';

export const SaveButton = ({ buttonText, disabled }) => {
  const i18n = useContext(I18nContext);

  const { state, send } = useFormService();
  const isBlocking = state.matches(FORM_STATES.FETCHING) || state.matches(FORM_STATES.LOADING) || state.matches(FORM_STATES.SAVING);

  const onSaveClicked = useCallback(() => {
    send(FORM_EVENTS.SAVE);
  }, [send]);

  return (
    <PrimaryButton
      disabled={disabled || isBlocking}
      onClick={onSaveClicked}
      className="form-save-button"
    >
      {buttonText || i18n.getString(_TL_('Save'))}
    </PrimaryButton>
  );
};
SaveButton.propTypes = {
  buttonText: PropTypes.string,
  disabled: PropTypes.bool,
};
SaveButton.defaultProps = {
  buttonText: undefined,
  disabled: false,
};

export const CancelButton = ({ buttonText }) => {
  const i18n = useContext(I18nContext);

  const { state, send } = useFormService();
  const isBlocking = state.matches(FORM_STATES.FETCHING) || state.matches(FORM_STATES.LOADING) || state.matches(FORM_STATES.SAVING);

  const onCancelClicked = useCallback(() => {
    send(FORM_EVENTS.CANCEL);
  }, [send]);

  return (
    <DefaultButton
      disabled={isBlocking}
      onClick={onCancelClicked}
      className="form-cancel-button"
    >
      {buttonText || i18n.getString(_TL_('Cancel'))}
    </DefaultButton>
  );
};
CancelButton.propTypes = {
  buttonText: PropTypes.string,
};
CancelButton.defaultProps = {
  buttonText: undefined,
};
